import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from 'src/providers/authProvider';

const useRedirectIfNotAuthorized = (redirectLocation) => {
  const navigate = useNavigate();
  const { loading, isLoggedIn, isAdmin, ...rest } = useContext(AuthContext);

  useEffect(() => {
    if (!loading && (!isLoggedIn || !isAdmin)) {
      navigate(redirectLocation || '/');
    }
  }, [isAdmin, isLoggedIn, loading, redirectLocation, navigate]);

  return {
    loading,
    isLoggedIn,
    isAdmin,
    ...rest,
  };
};

export default useRedirectIfNotAuthorized;
